import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useSetAtom } from 'jotai';
import React from 'react';
import { ScrollView, View } from 'react-native';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { font } from '@/constant/font';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import useNavigation from '@/navigation/useNavigation';
import { searchModeAtom } from '@/screens/SearchScreen/atoms';
import SearchCategoryIcon from '@/screens/SearchScreen/components/SearchHeader/SearchCategoryIcon';
const SEARCH_CATEGORIES = [
    {
        category: 'TOILET',
        label: '화장실',
        keyword: '장애인 화장실',
        mode: 'toilet',
    },
    {
        category: 'RESTAURANT',
        keyword: '음식점',
        mode: 'place',
    },
    {
        category: 'CAFE',
        keyword: '카페',
        mode: 'place',
    },
    {
        category: 'CONVENIENCE_STORE',
        keyword: '편의점',
        mode: 'place',
    },
    {
        category: 'HOISPITAL',
        keyword: '병원',
        mode: 'place',
    },
    {
        category: 'PHARMACY',
        keyword: '약국',
        mode: 'place',
    },
];
export default function CategoryChipSection() {
    const navigation = useNavigation();
    const setSearchMode = useSetAtom(searchModeAtom);
    const handlePress = (keyword, mode) => {
        setSearchMode(mode);
        navigation.navigate('Search', { initKeyword: keyword, toMap: false });
    };
    return (_jsx(LogParamsProvider, { params: { displaySectionName: 'category_chip_section' }, children: _jsx(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, style: { overflow: 'visible' }, contentContainerStyle: { paddingHorizontal: 20 }, children: _jsx(View, { style: { flexDirection: 'row', gap: 8 }, children: SEARCH_CATEGORIES.map(item => {
                    var _a;
                    return (_jsx(SccPressable, { elementName: "home_v2_category_chip", logParams: { category: item.category, keyword: item.keyword }, onPress: () => handlePress(item.keyword, item.mode), children: _jsxs(ChipInner, { children: [_jsx(SearchCategoryIcon, { icon: item.category, size: 20 }), _jsx(ChipText, { numberOfLines: 1, children: (_a = item.label) !== null && _a !== void 0 ? _a : item.keyword })] }) }, item.category));
                }) }) }) }));
}
const ChipInner = styled.View `
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  border-width: 1px;
  border-color: #fff;
  border-radius: 100px;
  min-width: 84px;
  flex-shrink: 0;
  padding: 8px 14px;
  gap: 4px;
  shadow-color: #000;
  shadow-offset: 0px 0px;
  shadow-opacity: 0.15;
  shadow-radius: 4px;
  elevation: 2;
`;
const ChipText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 14px;
  color: #16181c;
  line-height: 20px;
  letter-spacing: -0.28px;
`;
